module.exports = __webpack_public_path__ + "static/media/carlo.676a65cd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/about-us/carlo.png
// module id = 1161
// module chunks = 0